const VERIFICATION_ITEMS = [
    {
        id: 1,
        title: "Agreement Template",
        subtitle: "Contract Internancy agreement for skills development",
        tag: "DOCX",
        tag_class: "bg-primary",
        version: "5.1.58",
        type: "Contract Template",
        category: "Legal Documents",
        last_updated: "2023-10-15",
        status: "Active",
        status_class: "bg-success",
        icon: "bi-file-earmark-word",
        icon_color_class: "text-primary",
        icon_bg_class: "bg-primary-subtle",
        progress: 100,
        description: "This template provides a standardized agreement for internship programs focused on skills development. It includes clauses for duration, responsibilities, and evaluation criteria.",
        preview_title: "[DOCX + 5.1.58]",
        preview_subtitle: "Contract Internancy agreement for skills development",
        code_language: "XML",
        code_content: `<contract>\n  <type>Internship Agreement</type>\n  <parties>\n    <employer>Leuvenzijen Corp</employer>\n    <intern>Skills Development Intern</intern>\n  </parties>\n  <duration>6 months</duration>\n  <skills>\n    <skill>Project Management</skill>\n    <skill>Technical Documentation</skill>\n  </skills>\n</contract>`
    },
    {
        id: 2,
        title: "Skills Levy Declaration",
        subtitle: "Directors and skills development levy combination",
        tag: "VOL",
        tag_class: "bg-info",
        version: "5.2.58",
        type: "Declaration Form",
        category: "Tax Documents",
        last_updated: "2023-11-03",
        status: "Pending Review",
        status_class: "bg-warning",
        icon: "bi-file-earmark-pdf",
        icon_color_class: "text-warning",
        icon_bg_class: "bg-warning-subtle",
        progress: 75,
        description: "Declaration form for company directors to report skills development levies in accordance with regional regulations and compliance requirements.",
        preview_title: "[VOL + 5.2.58]",
        preview_subtitle: "Directors and skills development levy combination",
        code_language: "JSON",
        code_content: `{\n  "document": "Skills Levy Declaration",\n  "version": "5.2.58",\n  "director": "John Smith",\n  "company": "Example Corp",\n  "levy_amount": 12500,\n  "development_fund": "Skills Growth Initiative",\n  "filing_date": "2023-11-03"\n}`
    },
    {
        id: 3,
        title: "Affiliate of Ownership",
        subtitle: "Owner and contractor of sales ownership guarantor",
        tag: "VOL",
        tag_class: "bg-info",
        version: "5.2.58",
        type: "Ownership Document",
        category: "Legal Documents",
        last_updated: "2023-09-22",
        status: "Active",
        status_class: "bg-success",
        icon: "bi-folder-fill",
        icon_color_class: "text-success",
        icon_bg_class: "bg-success-subtle",
        progress: 50,
        description: "Document establishing affiliate ownership structures between property owners and sales contractors with guaranteed ownership clauses.",
        preview_title: "[VOL + 5.2.58]",
        preview_subtitle: "Owner and contractor of sales ownership guarantor",
        code_language: "YAML",
        code_content: `document: Affiliate of Ownership\nversion: 5.2.58\nowner:\n  name: "Jane Doe"\n  id: "OWN-23456"\naffiliate:\n  name: "Sales Contractors Inc"\n  type: "Sales Agent"\nguarantor: "Global Guarantee Corp"\nvalidity: "2 years"\n`
    },
    {
        id: 4,
        title: "YES Employment Contract Template",
        subtitle: "Service/YES Programmer employment agreement",
        tag: "DOCX",
        tag_class: "bg-primary",
        version: "5.2.58",
        type: "Employment Contract",
        category: "HR Documents",
        last_updated: "2023-10-28",
        status: "Active",
        icon: "bi-file-earmark-word",
        icon_color_class: "text-primary",
        icon_bg_class: "bg-primary-subtle",
        progress: 100,
        status_class: "text-success",
        description: "Standardized employment agreement for programmers in the Service/YES program, covering terms, compensation, and intellectual property rights.",
        preview_title: "[DOCX + 5.2.58]",
        preview_subtitle: "Service/YES Programmer employment agreement",
        code_language: "XML",
        code_content: `<employment_contract>\n  <program>YES Programmer</program>\n  <employee_role>Service Developer</employee_role>\n  <compensation>\n    <salary>Competitive</salary>\n    <bonus_structure>Performance-based</bonus_structure>\n  </compensation>\n  <duration>Permanent</duration>\n  <probation_period>3 months</probation_period>\n</employment_contract>`
    },
    {
        id: 5,
        title: "Bringing Interest",
        subtitle: "Interest calculation and accrual document",
        tag: "DOCX",
        tag_class: "bg-primary",
        version: "5.2.58",
        type: "Financial Document",
        category: "Finance",
        last_updated: "2023-11-10",
        status: "Draft",
        icon: "bi-file-earmark-spreadsheet",
        icon_color_class: "text-secondary",
        icon_bg_class: "bg-secondary-subtle",
        progress: 60,
        description: "Document outlining interest calculation methodologies and accrual processes for financial products and investment instruments.",
        preview_title: "[DOCX + 5.2.58]",
        preview_subtitle: "Interest calculation and accrual document",
        code_language: "JavaScript",
        code_content: `function calculateInterest(principal, rate, time) {\n  // Compound interest calculation\n  const amount = principal * Math.pow(1 + rate/100, time);\n  const interest = amount - principal;\n  return {\n    principal: principal,\n    rate: rate,\n    time: time,\n    amount: amount,\n    interest: interest\n  };\n}`
    },
    {
        id: 6,
        title: "Benefit",
        subtitle: "Targeted benefit allocation framework",
        tag: "DOCX",
        tag_class: "bg-primary",
        version: "5.2.58",
        type: "Policy Document",
        category: "HR Documents",
        last_updated: "2023-10-05",
        status: "Active",
        icon: "bi-file-earmark-text",
        icon_color_class: "text-danger",
        icon_bg_class: "bg-danger-subtle",
        progress: 80,
        status_class: "text-success",
        description: "Framework for allocating targeted benefits to employees based on performance, tenure, and organizational contribution metrics.",
        preview_title: "[DOCX + 5.2.58]",
        preview_subtitle: "Targeted benefit allocation framework",
        code_language: "Python",
        code_content: `class BenefitAllocation:\n    def __init__(self, employee_id, performance_score, tenure):\n        self.employee_id = employee_id\n        self.performance = performance_score\n        self.tenure = tenure  # in years\n        \n    def calculate_benefits(self):\n        base_benefit = 1000\n        performance_bonus = self.performance * 100\n        tenure_bonus = min(self.tenure, 10) * 50\n        total = base_benefit + performance_bonus + tenure_bonus\n        return total`
    }
];

const clone_list = (list) => list.map((item) => ({ ...item }));

export default {
    name: "VerificationComponent",
    props: {
        is_verification_view: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return ({
            search_query: '',
            active_item_id: 1,
            expanded_items: [],
            items: clone_list(VERIFICATION_ITEMS)
        });
    },
    computed: {
        filtered_items() {
            if (!this.search_query) {
                return this.items;
            }
            const query = this.search_query.toLowerCase();
            return this.items.filter(item =>
                item.title.toLowerCase().includes(query) ||
                item.subtitle.toLowerCase().includes(query) ||
                item.category.toLowerCase().includes(query)
            );
        },
        selected_item() {
            return this.items.find(item => item.id === this.active_item_id);
        },
        expanded_items_set() {
            const set = {};
            this.expanded_items.forEach(id => {
                set[parseInt(id,10)] = true;
            });
            return set;
        }
    },
    methods: {
        select_item(id) {
            this.active_item_id = id;
        },
        toggle_expand(id) {
            const index = this.expanded_items.indexOf(id);
            if (index > -1) {
                this.expanded_items.splice(index, 1);
            } else {
                this.expanded_items.push(id);
            }
        }
    }
};